import { render, staticRenderFns } from "./BlobSnowflake.vue?vue&type=template&id=67871b93&scoped=true"
import script from "./BlobSnowflake.vue?vue&type=script&lang=js"
export * from "./BlobSnowflake.vue?vue&type=script&lang=js"
import style0 from "./BlobSnowflake.vue?vue&type=style&index=0&id=67871b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67871b93",
  null
  
)

export default component.exports